<template>
  <div class="login container">
    <div v-if="!redeemCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <div v-else>
        <div class="row">

        <h1 class="col-md-12 pt-5">Success!</h1>

        </div>

        <div class="row d-flex justify-content-center pt-3">

          <div class="numberCircle">1</div>

        </div>

        <div class="row d-flex justify-content-center">

          <p>Hand the card back to the customer if it's a physical card.</p>
          </div>

        <div class="row d-flex justify-content-center">
          <div class="numberCircle">2</div>
        </div>

          <div class="row d-flex justify-content-center">
          <p>Remember to reduce the bill on your till system by </p>
          </div>
          <div class="row d-flex justify-content-center pb-4">
          <h1>{{getPriceDisplay(lastCard.Currency,lastRedemptionAmount)}}</h1>
          </div>

        <div class="row d-flex justify-content-center pt-4 pb-4">

          <cta link="home"  text="Finish" />

        </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        amount:''
      };
  },
  computed: {

    lastCard()
    {
        return this.$store.getters.getLastCard;
    },

    lastRedemptionAmount()
    {
        return this.$store.getters.getLastRedemptionAmount;
    },
  },
  methods:{

      


  }
}
</script>

<style scoped>

.half p{
  max-width: 300px;
  margin: 0 auto;
}

h1{
  margin-top:0;
}

</style>
